import { useRef, useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";

import EditProfileModal from "../components/EditProfileModal";
import Posts from "../components/Posts";

import { IoCalendarOutline } from "react-icons/io5";
import { FaLink, FaArrowLeft } from "react-icons/fa";
import { MdEdit } from "react-icons/md";

import { useAuthContext } from "../hooks/useAuthContext";
import { useFollow } from '../hooks/useFollow';
import { useQuery } from "@apollo/client";
import { GET_USER_PROFILE } from '../queries/userQueries';
import { formatMemberSinceDate } from "../utils/date";
import { useUpdateUserProfile } from "../hooks/useUpdateUserProfile";
import Spinner from "../components/Spinner";
import { PostsContextProvider } from "../context/PostsContext";

export default function Profile() {
  const { id } = useParams()
  const { followUnfollow, isLoading } = useFollow()
  const { updateProfile } = useUpdateUserProfile()
  const { authUser } = useAuthContext()

  const [userProfile, setUserProfile] = useState([])
  const [feedType, setFeedType] = useState("forYou")

  const { data, refetch, loading } = useQuery(GET_USER_PROFILE, {
    variables: { id },
	onCompleted: (data) => {
	  if (data.userProfile) {
	 	setUserProfile(data.userProfile)
	  }
	}
  })

  useEffect(() => {
	refetch()
  }, [id, refetch])

  const coverImgRef = useRef(null)
  const profileImgRef = useRef(null)

  /*const [modalOpen, setModalOpen] = useState(false)

  const updateAvatar = (imgSrc) => {
	//console.log(profileImgRef.current)
	console.log('crop done')
    profileImgRef.current = imgSrc
	setProfileImg(imgSrc)
	//console.log(profileImgRef.current)
  }*/

  const handleImgChange = (e, state) => {
    const file = e.target.files[0]
	if (file) {
	  const reader = new FileReader()
	  reader.onload = async () => {
	    state === "coverImg" && await updateProfile(authUser?.id, { coverImg: reader.result }) //setCoverImg(reader.result)
		state === "profileImg" && await updateProfile(authUser?.id, { profileImg: reader.result }) //setProfileImg(reader.result)
		console.log(reader.result)
	  }
	  reader.readAsDataURL(file)
	}
  }

  const followers = userProfile.followers

  const following = userProfile.following

  if (loading) return <Spinner marginSize='60px' />
  
  const isMyProfile = authUser?.id === data.userProfile?.id
  const memberSinceDate = formatMemberSinceDate(data.userProfile?.createdAt)
  const amIFollowing = authUser.following.some((follow) => {
	return follow.id === data.userProfile?.id
  })

  return (
	<div className='col-auto border-start border-end border-secondary min-vh-100'>
	  {/* Header */}
	  {!loading && !data && <p className="text-center text-lg mt-4">User not found</p>}
	  <div className="d-flex flex-column">
	    {!loading && data && (
		  <>
			<div className='d-flex align-items-center px-4 py-2'>
			  <Link to='/' className="btn text-violet border-0">
				<FaArrowLeft className='me-3 w-4' />
			  </Link>

			  <div className='d-flex flex-column'>
				<p className='fw-bold text-violet rfs-4 mb-1'>{data.userProfile?.username}</p>
				<span className='text-muted small'>{data.userProfile?.posts?.length} posts</span>
			  </div>
			</div>

			{/* COVER IMG */}
			<div className='position-relative border border-start-0 border-end-0 border-top-violet border-bottom-violet'>
			  <img
				src={data.userProfile?.coverImg || "/assassin.jpg"}
				className='img-fluid w-100'
				style={{ height: "20rem" }}
				alt='cover image'
			  />

			  <div className="position-absolute m-2 bottom-0 end-0">
				{isMyProfile && (
				  <MdEdit
				  	className='btn btn-secondary rounded-circle border border-violet rfs-1 p-1 text-white'
				  	onClick={() => coverImgRef.current.click()}
				  />
				)}
			  </div>

			  <input
				type='file'
				hidden
				accept='image/*'
				ref={coverImgRef}
				onChange={(e) => handleImgChange(e, "coverImg")}
			  />

			  <input
				type='file'
				hidden
				accept='image/*'
				ref={profileImgRef}
				onChange={(e) => handleImgChange(e, "profileImg")}
			  />

			  {/* USER AVATAR */}
			  <div className='position-absolute position-relative bottom-0 start-0 mb-4 ms-4'>
				<div className='rounded-circle overflow-hidden border border-violet' style={{ width: "128px", height: "128px" }}>
				  <img src={data.userProfile?.profileImg || "/gunslinger.jpg"} className="w-100 h-100" />
				  
				  <div className="position-absolute z-1 w-100 text-center" style={{ top: '112px' }}>
				    {isMyProfile && (
					  <MdEdit
					    className='btn btn-secondary rounded-circle border border-violet rfs-1 p-1 text-white'
					    onClick={() => profileImgRef.current.click() /*setModalOpen(true)*/}
					  />
				    )}
				  </div>
				</div>
			  </div>

			  {/*modalOpen && (
				<Modal
				  updateAvatar={updateAvatar}
				  closeModal={() => setModalOpen(false)}
				/>
			  )*/}
			</div>

			<div className='d-flex justify-content-end px-4 mt-5'>
			  {/* EditProfile */}
			  {isMyProfile && /*(!coverImg && !profileImg) &&*/ <EditProfileModal authUser={authUser} />}
			  
			  {/* FollowUnfollow */}
			  {!isMyProfile && (
				<button	
				  className='btn btn-violet rfs-4'
				  onClick={() => followUnfollow(authUser?.id, data.userProfile?.id)}
				>
				  {isLoading && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
				  {!isLoading && amIFollowing && "Unfollow"}
				  {!isLoading && !amIFollowing && "Follow"}
				</button>
			  )}
			  
			  {/* Edit Images */}
			  {/*(coverImg || profileImg) && (
				<button
				  className='btn btn-violet rfs-5'
				  onClick={async () => {
					await updateProfile(authUser?.id, { coverImg, profileImg })
					setProfileImg(null)
					setCoverImg(null)
				  }}
				>
				  {isUpdating && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
				  {!isUpdating && coverImg && 'Edit cover image'}
				  {!isUpdating && profileImg && 'Edit profile image'}
				</button>
			  )*/}
			</div>

			{/* User Info */}
			<div className='d-flex flex-column gap-4 mt-14 px-4'>
			  <div className='d-flex flex-column'>
				<span className='fw-bold'>{data.userProfile?.fullname}</span>
				<span className='text-sm text-slate-500'>@{data.userProfile?.username}</span>
			  </div>

			  <div className='d-flex flex-wrap'>
			    {data.userProfile?.link && data.userProfile?.email && (
				  <div className='d-flex items-align-center rfs-5'>
					<>
					  <FaLink className='mt-1 me-1' />
					  <a
						href={data.userProfile?.link}
						target='_blank'
						rel='noreferrer'
						className='text-info'
					  >
						My_Link
					  </a>
					</>
				  </div>
				)}

				<div className='d-flex mx-1 items-align-center rfs-5'>
				  <IoCalendarOutline className='mx-1 mt-1' />
				  <span className=''>{memberSinceDate}</span>
				</div>
			  </div>

			  {/* Following & Followers */}
			  <div className='d-flex'>
				<div className='d-flex items-align-center fw-bold rfs-5'>
				  <span className='me-1'>{following?.length}</span>
				  <span className='me-2'>Following</span>
				</div>

				<div className='d-flex items-align-center fw-bold rfs-5'>
				  <span className='me-1'>{followers?.length}</span>
				  <span>Followers</span>
				</div>
			  </div>
			</div>

			{/* Posts */}
			{isMyProfile && (
			  <div className='d-flex border-bottom border-2 mt-4'>
				<div
				  className='flex-fill mx-2 p-3 text-center position-relative cursor-pointer'
				  onClick={() => setFeedType("forYou")}
				>
				  <span className="rfs-5">My Posts</span>
				  {feedType === "forYou" && (
					<div className="position-absolute bottom-0 start-50 translate-middle-x rounded rounded-pill bg-primary" style={{ width: "2rem", height: "0.25rem" }} />
				  )}
				</div>
  
				<div
				  className='flex-fill mx-2 p-3 text-center position-relative cursor-pointer'
				  onClick={() => setFeedType("likes")}
				>
				  <span className="rfs-5">Liked Posts</span>
				  {feedType === "likes" && (
					<div className="position-absolute bottom-0 start-50 translate-middle-x rounded rounded-pill bg-primary" style={{ width: "2rem", height: "0.25rem" }} />
				  )}
				</div>
  
				<div
				  className='flex-fill mx-2 p-3 text-center position-relative cursor-pointer'
				  onClick={() => setFeedType("following")}
				>
				  <span className="rfs-5">Followings</span>
				  {feedType === "following" && (
					<div className="position-absolute bottom-0 start-50 translate-middle-x rounded rounded-pill bg-primary" style={{ width: "2rem", height: "0.25rem" }} />
				  )}
				</div>
			  </div>
			)}
		  </>
		)}

		<PostsContextProvider userId={id} feedType={feedType}>
		  <Posts userId={id} feedType={feedType} />
		</PostsContextProvider>
	  </div>
	</div>
  )
}
